import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {selectKeyWindowById, setKeyWindowOffset} from '../../features/keyWindowsSlice';
import {fetchCasesByStatus} from '../../features/thunks';
import {useAuth} from '../auth';

export const useKeyWindowId = ({category, statuses, orderBy, sortOrder}: {
    category?: string,
    statuses: string[],
    orderBy: string,
    sortOrder?: string
}) => {
    const auth = useAuth();
    const userId = auth.user ? auth.user.id : undefined;
    const statusesKey = statuses.join(',');

    return [statusesKey, category, userId, orderBy, sortOrder].filter(Boolean).join('_');
}

export const usePagination = ({
    pageSize,
    orderBy,
    initialPageSize,
    statuses,
    category,
    sortOrder
} : {
    pageSize: number,
    orderBy: string,
    initialPageSize: number,
    statuses: string[],
    category?: string,
    sortOrder?: string
}) => {
    const auth = useAuth();
    const userId = auth.user ? auth.user.id : undefined;
    const statusesKey = statuses.join(',');
    const keyWindowId = useKeyWindowId({category, statuses, orderBy, sortOrder});
    const dispatch = useDispatch();
    const keyWindow = useSelector(state => selectKeyWindowById(state, keyWindowId));
    const offset = keyWindow ? keyWindow.offset : 0;
    const currentPageSize = offset === 0 ? initialPageSize : pageSize;

    const itemsLeft = Math.max((keyWindow && keyWindow.found) ? keyWindow.found - (offset + currentPageSize) : 0, 0);

    useEffect(() => {
        dispatch(fetchCasesByStatus({
            category: category,
            status: statusesKey,
            limit: offset === 0 ? initialPageSize : pageSize,
            offset: offset,
            userId: userId,
            orderBy: orderBy,
            sortOrder: sortOrder
        }))
    }, [dispatch, statusesKey, pageSize, offset, category, initialPageSize, userId, orderBy, sortOrder]);

    return {
        fetchNextPage: () => {
            dispatch(setKeyWindowOffset({
                id: keyWindowId,
                offset: offset + currentPageSize
            }))
        },
        itemsLeft: itemsLeft,
        hasNextPage: itemsLeft > 0
    }
}
